import React from 'react';
import styled from 'styled-components';

const OrderSideCellRenderer: React.FunctionComponent<{value: string}> = ({ value: orderSide }) => <OrderSideCell orderSide={orderSide}>{orderSide}</OrderSideCell>;

export default OrderSideCellRenderer;

const OrderSideCell = styled.div<{orderSide: string}>`
  height: 22px;
  width: 100%;
  color: white;
  text-align: center;
  transition: background-color 0.2s ease-in-out;
  background-color: ${({ orderSide, theme }) => {
    if (orderSide === 'BUY') {
      return theme.template.green.normal;
    }

    if (orderSide === 'STOPOUT') {
      return theme.template.yellow.normal;
    }

    if (orderSide === 'SELL') {
      return theme.template.red.normal;
    }

    return;
  }};
`;
